module.exports = __webpack_public_path__ + "static/media/person.526faeb8.svg";